export class EquipmentLineItemType {
    ID?: number;
    Name?: string;
}

export default EquipmentLineItemType;